import React, { useEffect, useState } from 'react';
import {
  Container, Grid, Typography, TextField, Button, MenuItem, Select, FormControl, Checkbox, InputLabel, Paper, Box, Table, TableBody,
  TableCell, TableContainer, TableHead, TableRow, CircularProgress, Backdrop, TablePagination, Snackbar, Alert,
  Dialog, DialogActions, DialogContent, DialogTitle, TableSortLabel, DialogContentText,
  useScrollTrigger
} from '@mui/material';
import MetricCard from './MetricCard';
import PersonIcon from '@mui/icons-material/Person';
import ArticleIcon from '@mui/icons-material/Article';
import DescriptionIcon from '@mui/icons-material/Description';
import WorkIcon from '@mui/icons-material/Work';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import fetchData from '../../components/fetchData';
import MetricView from './MetricView';


const data = {
  "metrics": {
    "users": {
      "total": 1345,
      "detail": [
        { "week": "Week 1", "value": 240 },
        { "week": "Week 2", "value": 220 },
        { "week": "Week 3", "value": 160 },
        { "week": "Week 4", "value": 210 },
        { "week": "Week 5", "value": 180 },
        { "week": "Week 6", "value": 235 }
      ]
    },
    "articles": {
      "total": 12345,
      "detail": [
        { "week": "Week 1", "value": 2100 },
        { "week": "Week 2", "value": 1720 },
        { "week": "Week 3", "value": 1890 },
        { "week": "Week 4", "value": 1500 },
        { "week": "Week 5", "value": 2300 },
        { "week": "Week 6", "value": 2105 }
      ]
    },
    "jobs": {
      "total": 52345,
      "detail": [
        { "week": "Week 1", "value": 3500 },
        { "week": "Week 2", "value": 3720 },
        { "week": "Week 3", "value": 4890 },
        { "week": "Week 4", "value": 4100 },
        { "week": "Week 5", "value": 5300 },
        { "week": "Week 6", "value": 4835 }
      ]
    },
    "credits": {
      "total": 12345,
      "detail": [
        { "week": "Week 1", "value": 2100 },
        { "week": "Week 2", "value": 1720 },
        { "week": "Week 3", "value": 1890 },
        { "week": "Week 4", "value": 1500 },
        { "week": "Week 5", "value": 2300 },
        { "week": "Week 6", "value": 2105 }
      ]
    }
  }
}

function Statistics() {
  const [contentData, setContentData] = useState({});
  const [jobData, setJobData] = useState({});
  const [creditData, setCreditData] = useState({});
  const [userCreatedData, setUserCreatedData] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadData() {
      try {
        // Run both requests in parallel
        const [contentData, jobData, creditData, userCreatedData] = await Promise.all([
          fetchData({
            url: `${process.env.REACT_APP_API_BASE_URL}ai/writer/v1/content/totalCount`,
            method: 'POST',
            body:{totalDays:30}
          }),
          fetchData({
            url: `${process.env.REACT_APP_API_BASE_URL}ai/writer/v1/job/totalCount`,
            method: 'POST',
            body:{totalDays:30}
          }),
          fetchData({
            url: `${process.env.REACT_APP_API_BASE_URL}xeo/v1/creditUsage/totalCount`,
            method: 'POST',
            body:{totalDays:30}
          }),
          fetchData({
            url: `${process.env.REACT_APP_API_BASE_URL}xeo/v1/user/created/totalCount`,
            method: 'POST',
            body:{totalDays:30}
          }),
        ]);

        setContentData(contentData);
        setJobData(jobData);
        setCreditData(creditData);
        setUserCreatedData(userCreatedData);
      } catch (err) {
        console.error("Failed to fetch counts:", err);
      } finally {
        setLoading(false);
      }
    }

    loadData();
  }, []);

  return (
    <Container maxWidth={false} sx={{ width: '100%', padding: 0, paddingBottom: '5px' }}>
      <Box alignItems="center" sx={{ paddingTop: '10px' }}>
        <Box item xs={4.5}>
          <Typography variant="h5" gutterBottom paddingLeft={"6px"}>
            Statistics
          </Typography>
        </Box>
      </Box>
      {loading ? (
        <Backdrop open={true} style={{ color: '#fff', zIndex: 1 }}>
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : (
        <>
          {/*  top view  */}
          <Grid container spacing={3} sx={{ mt: 0 }}>
            <Grid item xs={12} sm={6} lg={3}>
              <MetricView title="Articles Created" data={contentData} icon={<ArticleIcon />} />
            </Grid>
            <Grid item xs={12} sm={6} lg={3}>
              <MetricView title="Jobs Created" data={jobData} icon={<WorkIcon />} />
            </Grid>
            <Grid item xs={12} sm={6} lg={3}>
              <MetricView title="Credits Used" data={creditData} icon={<CreditCardIcon />} />
            </Grid>
            <Grid item xs={12} sm={6} lg={3}>
              <MetricView title="New Users" data={userCreatedData} icon={<PersonIcon />} />
            </Grid>
          </Grid>
          {/*  chart  */}
          <Grid container spacing={5} sx={{ mt: 0 }}>
            <Grid item xs={12} md={12}>
              <MetricCard title="Articles" data={contentData} />
            </Grid>
            <Grid item xs={12} md={12}>
              <MetricCard title="Jobs" data={jobData} />
            </Grid>
            <Grid item xs={12} md={12}>
              <MetricCard title="Credits" data={creditData} />
            </Grid>
            <Grid item xs={12} md={12}>
              <MetricCard title="New Users" data={userCreatedData} />
            </Grid>
          </Grid>
        </>
      )}
    </Container>
  )
}

export default Statistics;
